<template>
  <div class="price">
    <div class="price-text" :style="styleCss">{{ priceToFixedTwo }}</div>
    <div class="token" :style="`width:${width}rem;height:${width}rem;`">
      <img src="@/assets/mybox/home/musd52x52-max.png" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    price: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 0.28,
    },
    styleCss: {
      type: String,
      default: "",
    },
  },
  watch: {
    price(val) {
      this.priceToFixedTwo = this.toFixedTwo(val, true);
    },
  },
  data() {
    return {
      priceToFixedTwo: "",
    };
  },
  created() {
    this.priceToFixedTwo = this.toFixedTwo(this.price, true);
  },
};
</script>
<style lang="scss" scoped>
.price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .price-text {
    font-size: 0.28rem;
  }
  .token {
    width: 0.28rem;
    height: 0.28rem;
    margin-left: 0.1rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
